module.exports = __webpack_public_path__ + "img/logo.9ce60c64.png";